import { useEffect, useState } from 'react';
import { apiFetch } from '@/lib/auth';

/**
 * pre142: OAuth-Redirect-Ziel der Teams-Verknüpfung. Microsoft leitet nach dem
 * Login auf die App-URL mit ?code=…&state=… zurück. Dieser View löst den Code
 * gegen das Backend ein (POST /api/telephony/graph/link) und leitet zurück.
 *
 * Wird in main.tsx ausgewählt, sobald `code` UND `state` im Query stehen — daher
 * unabhängig vom Pfad und ohne eigenen Router.
 */
export default function TeamsCallback() {
  const [msg, setMsg] = useState('Verbinde mit Teams …');
  const [done, setDone] = useState(false);
  const home = window.location.origin + window.location.pathname;

  useEffect(() => {
    const p = new URLSearchParams(window.location.search);
    const code = p.get('code');
    const stateRaw = p.get('state') || '';
    const err = p.get('error_description') || p.get('error');
    // Provider aus dem state (base64url-JSON {u,t,p}). KEIN stiller Default —
    // ein fremder/Platzhalter-state (z. B. aus der Portal-OAuth-URL) soll klar scheitern.
    let provider: string | null = null;
    try {
      const decoded = JSON.parse(atob(stateRaw.replace(/-/g, '+').replace(/_/g, '/')));
      if (decoded?.p === 'webex' || decoded?.p === 'graph') provider = decoded.p;
    } catch { /* */ }
    const label = provider === 'webex' ? 'Webex' : provider === 'graph' ? 'Teams' : 'Telefonie';
    setMsg(`Verbinde mit ${label} …`);
    if (err) { setMsg(label + '-Verknüpfung abgebrochen: ' + err); setDone(true); return; }
    if (!provider) {
      setMsg('Ungültiger oder fehlender state-Parameter. Bitte die Verknüpfung über den „Verbinden"-Button in den Einstellungen starten — nicht über die OAuth-URL aus dem Entwicklerportal.');
      setDone(true); return;
    }
    if (!code) { setMsg('Kein Autorisierungscode erhalten.'); setDone(true); return; }
    const prov = provider;
    (async () => {
      try {
        const r = await apiFetch(`/api/telephony/${prov}/link`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ code }),
        });
        if (r.ok) {
          setMsg(`${label} verbunden ✓ — Sie werden zurückgeleitet …`);
          setTimeout(() => { window.location.href = home; }, 1200);
        } else {
          const t = await r.text().catch(() => '');
          setMsg('Verknüpfung fehlgeschlagen: ' + (t || r.status));
          setDone(true);
        }
      } catch (e) {
        setMsg('Fehler bei der Verknüpfung: ' + String(e));
        setDone(true);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: 'var(--bg)', color: 'var(--fg)', fontFamily: 'var(--font)', padding: 24,
    }}>
      <div style={{ maxWidth: 420, textAlign: 'center' }}>
        <div style={{ fontSize: 13, letterSpacing: '.2em', textTransform: 'uppercase', color: '#93c5fd', marginBottom: 10 }}>
          Telefonie-Verknüpfung
        </div>
        <div style={{ fontSize: 16, lineHeight: 1.5 }}>{msg}</div>
        {done && (
          <a href={home} style={{ display: 'inline-block', marginTop: 18, color: 'var(--accent, #60a5fa)' }}>
            Zurück zur Anwendung
          </a>
        )}
      </div>
    </div>
  );
}
